<template>
  <b-card
    v-if="originUtmsData"
    class="news-details-origin-utm-referrer"
    no-body
  >
    <b-card-header class="border-bottom">
      <b-card-title class="font-weight-bold text-secondary font-medium-3">
        <span>Source UTM Referrers</span>
      </b-card-title>
    </b-card-header>
    <div class="mt-2 mb-2">
      <b-row class="match-height mx-1 font-medium-1 font-weight-bold text-dark">
        <b-col cols="3">
          Ratio
        </b-col>
        <b-col cols="6">
          Referrer
        </b-col>
        <b-col cols="3">
          Count
        </b-col>
      </b-row>
      <b-row
        v-for="(item, index) in originUtmsData"
        :key="`origin-utms-item-${index}`"
        class="match-height mx-1 mt-1 font-medium-1"
      >
        <b-col cols="3">
          {{ item.ratio.toFixed(5) }}
        </b-col>
        <b-col
          cols="6"
        >
          {{ item.referer}}
        </b-col>
        <b-col
          cols="3"
        >{{ item.referer_count.toLocaleString() }}
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
    BRow, BCol, BCard, BCardTitle, BCardHeader, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardTitle,
        BCardHeader,
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    props: {
        originUtmsData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {}
    },
}
</script>
